import {
  Box, Button, Paper, Grid, Table, TableBody, TableContainer, TableHead,
  Snackbar, Typography, TablePagination,
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  Tooltip
} from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import styles from '../../../styles.module.css';
import { useDispatch, useSelector } from "react-redux";
import {
  ActionMsg, Breadcrumb, CustomePopover, dateConversion, DeleteDialog, HandleCloseSnackbar,
  HandleSort, StyledTableCell, StyledTableRow, useMessageHandler
} from "../../reusableComponent/Reusables";
import QualityEntryPrint from "./QualityEntryPrint";
import ReactToPrint from "react-to-print";
import qualitycontrolService from "../../../services/qualitycontrol.Service";
import HeaderSection from "../../reusableComponent/HeaderSection";
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
import CustomPagination from "../../reusableComponent/CustomPagination";
import axiosClient from "../../../configs/axios";

import CloseIcon from '@mui/icons-material/Close';

const ComponentToPrintWrapper = ({ quotationPrint }) => {
  const ref = useRef();
  return (
    <div style={{ display: "flex" }}>
      <ReactToPrint
        trigger={() => (
          <span style={{ display: 'flex', justifyContent: 'center' }}>
            <PrintOutlinedIcon />
            <span style={{ marginLeft: '22px' }}>Print Record</span>
          </span>
        )}
        content={() => ref.current}
      />
      <div style={{ display: 'none' }}>
        <QualityEntryPrint ref={ref} salesOrderPrint={quotationPrint} />
      </div>
    </div>
  );
};

const QualityEntryList = () => {
  const dispatch = useDispatch();
  const login_details = sessionStorage.getItem('loginUser');
  const userD = JSON.parse(login_details);
  const userInfo = userD.userInfo;

  const totalCount = useSelector(state => state.quality_entry.total_count || 0);
  const defaultRowsPerPage = useSelector(state => state.quality_entry.rows_per_page || 15);
  const respMsgState = useSelector(state => state.quality_entry.message);

  const [rows, setRows] = useState([]);
  const [searchKey, setSearchKey] = useState('');
  const [successMessage, setSuccessMessage] = useState(null);
  const [sortBy, setSortBy] = useState(null);
  const [isDelete, setIsDelete] = useState(false);
  const [deleteInfo, setDeleteInfo] = useState();
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedCylinderDetails, setSelectedCylinderDetails] = useState([]);
  const [customermap, setCustomer] = useState([]);
  const [total_count, setTotalCount] = useState(null)
  const [dialogTitle, setDialogTitle] = useState("Cylinder Details");
  const [openCylinderDialog, setOpenCylinderDialog] = useState(false);
  useEffect(() => {
    setTotalCount(rows[0]?.totalCount);
  }, [rows]);
  const [controller, setController] = useState({
    page: 0,
    rowsPerPage: defaultRowsPerPage
  });

  useEffect(() => {
    setController(prev => ({
      ...prev,
      rowsPerPage: defaultRowsPerPage,
      page: 0,
    }));
  }, [defaultRowsPerPage]);

  const fetchData = async () => {
    try {
      const params = {
        page: controller.page,
        size: controller.rowsPerPage,
        searchKey: searchKey,
      };
      const response = await qualitycontrolService.getQualitycontrolList(params);
      setRows(response);
    } catch (error) {
      setSuccessMessage("Error fetching data");
    }
  };

  useEffect(() => {
    fetchData();
  }, [controller.page, controller.rowsPerPage, searchKey]);

  const handleChangePage = (event, newPage) => {
    setController(prev => ({ ...prev, page: newPage }));
  };

  const handleChangeRowsPerPage = (event) => {
    setController({
      ...controller,
      rowsPerPage: parseInt(event.target.value, 10),
      page: 0
    });
  };

  const handleSearch = (e) => {
    setSearchKey(e.target.value);
  };

  const deleteRecord = async (id) => {
    try {
      await qualitycontrolService.editDeleteQualitycontrol({
        quality_control_id: id,
        changedUpdatedValue: "delete"
      });
      setIsDelete(false);
      fetchData();
      setSuccessMessage("Record deleted successfully");
    } catch (error) {
      setSuccessMessage("Error deleting record");
    }
  };

  const handleDelete = (data) => {
    setIsDelete(true);
    setDeleteInfo(data);
  };

  const handleClose = () => {
    setIsDelete(false);
    setDeleteInfo(null);
  };

  const { shouldShowMsg, responseMessage } = useMessageHandler(fetchData, null, setSuccessMessage, respMsgState);

  useEffect(() => {
    if (respMsgState) {
      setSuccessMessage(respMsgState);
    }
  }, [respMsgState]);

  const sortedRows = [...rows].sort((a, b) => new Date(b.entry_date) - new Date(a.entry_date));

  const effectiveTotalCount = total_count > 0 ? total_count : rows.length > 0 ? rows.length : 0;
  const startRecord = effectiveTotalCount === 0 ? 0 : controller.page * controller.rowsPerPage + 1;
  const endRecord = effectiveTotalCount === 0 ? 0 : Math.min((controller.page + 1) * controller.rowsPerPage, effectiveTotalCount);
  const paginationInfo = `${startRecord}-${endRecord} of ${total_count}`;


  const toFileUrl = (url) => {
    if (!url) return "";
    const idx = url.indexOf("uploads/");
    if (idx === -1) return url;
    const origin = (axiosClient.defaults.baseURL || "").replace(/\/api\/?$/, "");
    return `${origin}/${url.slice(idx)}`;
  };

  const isImageUrl = (url) => /\.(jpg|jpeg|png)(\?.*)?$/i.test(url);

  const renderPhoto = (filePath) => {
    if (!filePath) return "—";
    const url = toFileUrl(filePath);
    return isImageUrl(url) ? (
      <a href={url} target="_blank" rel="noreferrer">
        <img src={url} alt="gauge"
          style={{ width: 32, height: 32, objectFit: "cover", borderRadius: 4, border: "1px solid #E2E8F0", verticalAlign: "middle" }} />
      </a>
    ) : (
      <a href={url} target="_blank" rel="noreferrer" style={{ color: "#1976d2", textDecoration: "underline" }}>📄 PDF</a>
    );
  };

  const handleOpenDialog = (row) => {
    setSelectedRow(row); // Make sure this runs before dialog opens
    // const parsed = safeParse(row.table_details);
    setSelectedCylinderDetails(safeParse(row.table_details));
    setOpenDialog(true);
  };
  const safeParse = (jsonString) => {
    try {
      return JSON.parse(jsonString || '[]');
    } catch (e) {
      return [];
    }
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedRow(null);
    setSelectedCylinderDetails([]);
  };
  const handleCylinderCountClick = (row) => {
    try {
      const details = JSON.parse(row.table_details || '[]');
      setSelectedCylinderDetails(details);
      setDialogTitle(`Cylinder Details for ${row.entry_no}`);
      setOpenCylinderDialog(true);
    } catch (error) {
      console.error("Error parsing table_details:", error);
      setSuccessMessage("Error loading cylinder details");
    }
  };
  const getCylinderCount = (row) => {

    if (row.cylinder_count) {
      return row.cylinder_count;
    }

    try {
      const details = JSON.parse(row.child_details || '[]');
      return details.length || 0;
    } catch (error) {
      console.error("Error parsing child_details:", error);
      return 0;
    }
  };
  const handleCloseCylinderDialog = () => {
    setOpenCylinderDialog(false);
    setSelectedCylinderDetails([]);
    setDialogTitle("Cylinder Details");
  }

  const getOwnerDisplay = (cylinder) => {
    if (!cylinder) return 'N/A';
    const { owner, customer_id } = cylinder;
    if (owner === 'TGPL') return 'TGPL';
    if (owner === 'customer' && customer_id && customermap[customer_id]) {
      return customermap[customer_id];
    }
    return owner || 'N/A';
  };



  return (
    <Box className={`${styles.cts_page}`} sx={{ padding: '0px !important', margin: '0px !important' }}>
      <Box className={`${styles.body}`}>
        <Breadcrumb routeSegments={[{ name: 'Quality Entry List' }]} />

        <HeaderSection
          title="QUALITY ENTRY LIST"
          addNewPath="/productionEntries/add-qe"
          searchKey={searchKey}
          handleSearch={handleSearch}
          sortedRows={sortedRows}
          fields={['entry_no', 'entry_date', 'batch_no', 'prod_code', 'cylinder_count', 'plant_name']}
          labels={['Entry NO ', 'Entry Date', 'Batch No ', 'Product Code ', 'No Of cylinder',' From Plant Name']}
          filename="Quality Entry List"
          paginationInfo={paginationInfo}
          controller={controller}
          handleChangePage={handleChangePage}
          openscanner={false}
        />

        <Paper sx={{ width: '100%', }}>
          <TableContainer component={Paper} className={styles.list_tbl_container}>
            <Table size="small" stickyHeader>
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell sx={{ width: '15%' }} align="Left" className={`${styles.table_head}`} onClick={() => HandleSort('entry_date', sortBy, setSortBy, rows)}>Entry No</StyledTableCell>
                  <StyledTableCell sx={{ width: '15%' }} align="Left" className={`${styles.table_head}`} onClick={() => HandleSort('entry_date', sortBy, setSortBy, rows)}>Date</StyledTableCell>
                  <StyledTableCell sx={{ width: '15%' }} align="Left" className={`${styles.table_head}`} onClick={() => HandleSort('batch_no', sortBy, setSortBy, rows)}>Batch No</StyledTableCell>
                  {/* <StyledTableCell sx={{ width: '15%' }} align="Left" className={`${styles.table_head}`} onClick={() => HandleSort('prod_code', sortBy, setSortBy, rows)}>Product Code</StyledTableCell> */}
                  <StyledTableCell sx={{ width: '15%' }} align="center" className={`${styles.table_head}`} onClick={() => HandleSort('cylinder_count', sortBy, setSortBy, rows)}>No Of Cylinders</StyledTableCell>
                  {/* <StyledTableCell sx={{ width: '15%' }} align="Left" className={`${styles.table_head}`} onClick={() => HandleSort('from_plant_name', sortBy, setSortBy, rows)}>From Plant </StyledTableCell> */}
                  {/* <StyledTableCell align="center" className={`${styles.table_head}`} >Action</StyledTableCell> */}
                </StyledTableRow>
              </TableHead>
              <TableBody sx={{ backgroundColor: '#fff' }}>
                {Array.isArray(rows) && rows.map((row) => (
                  <StyledTableRow key={row.so_no}>
                    <StyledTableCell
                      align="left"
                      className={`${styles.list_table_body}`}
                    >
                      <Typography
                        sx={{
                          fontSize: "12px",
                          fontWeight: "bold",
                          cursor: "pointer",
                          color: "#1976d2",
                          textDecoration: "underline",
                        }}
                        onClick={() => handleOpenDialog(row)}
                      >
                        {row.entry_no || "N/A"}
                      </Typography>


                    </StyledTableCell>
                    <StyledTableCell align="left" className={`${styles.list_table_body}`}>
                      {new Date(row.entry_date).toLocaleDateString('en-GB')}
                    </StyledTableCell>

                    <StyledTableCell align="Left" className={`${styles.list_table_body}`}>{row.batch_no}</StyledTableCell>
                    {/* <StyledTableCell align="Left" className={`${styles.list_table_body}`}>{row.prod_code}</StyledTableCell> */}
                    <StyledTableCell align="center" className={`${styles.list_table_body}`}>
                      <Tooltip title="Click here to view cylinder details" arrow>
                        <span
                          onClick={() => handleCylinderCountClick(row)}
                          style={{ cursor: 'pointer' }}
                        >
                          {getCylinderCount(row)}
                        </span>
                      </Tooltip>
                    </StyledTableCell>
                    {/* <StyledTableCell align="Left" className={`${styles.list_table_body}`}>{row.from_plant_name}</StyledTableCell> */}
                    {/* <StyledTableCell align="center">
                      <CustomePopover
                        row={row}
                        handleDelete={false}
                        linkTo="/productionEntries/add-qe"
                        PrintComponent={QualityEntryPrint}
                        showEdit={false}
                        handlePrint={false}
                           handleCancel={false}
                      />
                    </StyledTableCell> */}
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
             <CustomPagination
  page={controller.page}
  rowsPerPage={controller.rowsPerPage}
  totalCount={total_count || 0}
  onPageChange={(newPage) => handleChangePage(null, newPage)}
/>
        </Paper>

        {/* ── QUALITY CONTROL DETAILS (Redesigned like Sales Order) ── */}
        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          maxWidth={false}
          sx={{
            "& .MuiDialog-paper": {
              margin: "auto",
              width: "92vw",
              maxHeight: "85vh",
              boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
              overflow: "hidden",
              fontFamily: "'Inter', Arial, sans-serif",
             
            },
          }}
        >
          {/* ── Dialog Header (Navy) ── */}
          <Box sx={{ background: "#1C3A5E", padding: "14px 22px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <Typography sx={{ fontSize: "14px", fontWeight: 700, color: "#fff", letterSpacing: "0.5px", fontFamily: "'Inter', Arial, sans-serif" }}>
              QUALITY CONTROL DETAILS
            </Typography>
            <IconButton onClick={handleCloseDialog} sx={{ color: "#fff", p: 0.5 }}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>

          <DialogContent sx={{ padding: "20px 24px", background: "#F4F7FB", overflowY: "auto" }}>

            {/* ── Quality Information Card ── */}
            <Box sx={{ background: "#fff", border: "1px solid #E2E8F0",  overflow: "hidden", mb: 2.5 }}>
              <Box sx={{ background: "#2A4F7A", padding: "9px 18px" }}>
                <Typography sx={{ fontSize: "12px", fontWeight: 700, color: "#fff", fontFamily: "'Inter', Arial, sans-serif", letterSpacing: "0.4px" }}>
                  📋  Quality Information
                </Typography>
              </Box>

              <Box>
                <Grid container>
                  {/* Row 1 */}
                  <Grid item xs={12} sm={6} md={3} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>Entry No</Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 700, color: "#1C3A5E", fontFamily: "'Inter', Arial, sans-serif" }}>{selectedRow?.entry_no || "N/A"}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>Entry Date</Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>{dateConversion(selectedRow?.entry_date)}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>Batch No</Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>{selectedRow?.batch_no || "N/A"}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3} sx={{ borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>Product Code</Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>{selectedRow?.prod_code || "N/A"}</Typography>
                  </Grid>

                  {/* Row 2 */}
                  {/* Row 2 */}
                  <Grid item xs={12} sm={6} md={3} sx={{ borderRight: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>Product Desc</Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{selectedRow?.prod_description || "N/A"}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3} sx={{ borderRight: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>Quality Supervisor</Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>{selectedRow?.quality_supervisor || "N/A"}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3} sx={{ borderRight: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>From Depot</Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>{selectedRow?.quality_supervisor || "N/A"}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3} sx={{ padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>Total Topup Qty</Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>{selectedRow?.total_topup_qty != null && selectedRow?.total_topup_qty !== "" ? `${selectedRow.total_topup_qty} KG` : "N/A"}</Typography>
                  </Grid>
                </Grid>
              </Box>
            </Box>

            {/* ── Cylinder Details Table ── */}
            <Box sx={{ background: "#fff", border: "1px solid #E2E8F0", overflow: "hidden" }}>
              
              <TableContainer sx={{ maxHeight: "350px" }}>
                <Table size="small" stickyHeader>
                  <TableHead>
                    <StyledTableRow>
                      {["Sr No", "Cylinder No", "Tag No", "Owner", "Product Purity", "Settled Pressure", "Leak Test", "Quality Result","Qty Filled", "Remarks","Topup Qty","Pressure Gauge Photo"].map((header) => (
                        <StyledTableCell
                          key={header}
                          align="center"
                          sx={{
                            backgroundColor: "#1C3A5E !important",
                            color: "#fff !important",
                            fontFamily: "'Inter', Arial, sans-serif",
                            fontWeight: 700,
                            fontSize: "11px", // Font size thoda chota kiya kyunki 9 columns hain
                            padding: "10px 8px",
                            whiteSpace: "nowrap",
                            borderRight: "1px solid rgba(255,255,255,0.1)",
                          }}
                        >
                          {header}
                        </StyledTableCell>
                      ))}
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {selectedCylinderDetails.length > 0 ? (
                      selectedCylinderDetails.map((row, index) => (
                        <StyledTableRow
                          key={index}
                          sx={{
                            backgroundColor: index % 2 === 0 ? "#fff" : "#F8FAFC",
                            "&:hover": { backgroundColor: "#EBF4FF" },
                          }}
                        >
                          {[
                            index + 1,
                            row.cyl_no || "N/A",
                            row.tag_no || "N/A",
                            row.owner === "TGPL"
                              ? "TGPL"
                              : row.customer_id
                              ? customermap[row.customer_id] || "Customer"
                              : "N/A",
                            row.product_purity || "N/A",
                            row.settled_pressure || "N/A",
                            row.leak_test || "N/A",
                            row.quality_result || "N/A",
                            row.qty_filled || "N/A",
                            row.remarks || "N/A",
                                                         row.topup_qty && parseFloat(row.topup_qty) > 0 ? parseFloat(row.topup_qty).toFixed(2) : 0,
                             renderPhoto(row.filePath)
                          ].map((val, ci) => (
                            <StyledTableCell
                              key={ci}
                              align="center"
                              sx={{
                                fontSize: "11px", // Chota font for 9 columns
                                fontFamily: "'Inter', Arial, sans-serif",
                                color: "#2D3748",
                                padding: "8px 6px",
                                borderBottom: "1px solid #EDF2F7",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {val}
                            </StyledTableCell>
                          ))}
                        </StyledTableRow>
                      ))
                    ) : (
                      <StyledTableRow>
                        <StyledTableCell
                          colSpan={9}
                          align="center"
                          sx={{ py: 5, fontSize: "13px", color: "#A0AEC0", fontFamily: "'Inter', Arial, sans-serif" }}
                        >
                          No cylinder details available
                        </StyledTableCell>
                      </StyledTableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>

          </DialogContent>

          {/* ── Dialog Footer ── */}
          <Box sx={{ padding: "12px 24px", background: "#F8FAFC", borderTop: "1px solid #E2E8F0", display: "flex", justifyContent: "flex-end" }}>
            <Button
              onClick={handleCloseDialog}
              sx={{
                background: "#E53E3E",
                color: "#fff",
                fontSize: "13px",
                fontWeight: 600,
                textTransform: "none",
                padding: "7px 20px",
                borderRadius: "8px",
                fontFamily: "'Inter', Arial, sans-serif",
                "&:hover": { background: "#971f16" },
              }}
            >
              Close
            </Button>
          </Box>
        </Dialog>

        <Dialog
          open={openCylinderDialog}
          onClose={handleCloseCylinderDialog}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            {dialogTitle}
            <IconButton aria-label="close" onClick={handleCloseCylinderDialog}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <Table size="small">
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell>Cylinder No</StyledTableCell>
                  <StyledTableCell>Tag No</StyledTableCell>
                  <StyledTableCell>Owner</StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {selectedCylinderDetails.length > 0 ? (
                  selectedCylinderDetails.map((cylinder, index) => (
                    <StyledTableRow key={index}>
                      <StyledTableCell>{cylinder.cyl_no || 'N/A'}</StyledTableCell>
                      <StyledTableCell>{cylinder.tag_no || 'N/A'}</StyledTableCell>
                      <StyledTableCell>{getOwnerDisplay(cylinder)}</StyledTableCell>
                    </StyledTableRow>
                  ))
                ) : (
                  <StyledTableRow>
                    <StyledTableCell colSpan={3} align="center">
                      No cylinder details available
                    </StyledTableCell>
                  </StyledTableRow>
                )}
              </TableBody>
            </Table>
          </DialogContent>
        </Dialog>



        <DeleteDialog
          open={isDelete}
          handleClose={handleClose}
          deleteInfo={deleteInfo}
          deleteRecord={deleteRecord}
          deleteID={deleteInfo?.quality_control_id}
          displayName={deleteInfo?.quality_control_id}
        />
        <ReusableSnackbar
          open={!!successMessage}
          onClose={(event, reason) => {
            if (reason !== 'clickaway') {
              setSuccessMessage("");
            }
          }}
          message={successMessage}
          autoHideDuration={2000}
          vertical="top"
          horizontal="right"
        />
      </Box>
    </Box>
  );
};

export default QualityEntryList;